import { hostMatchesDomain } from './hostMatchesDomain';

// A copy of Restyle:AllowedLinkDomains in webapi/appsettings.json, the hosts our help content links to
// (plus eaccounting.nl, the Dutch support portal the support-contact reply links to). It is tunable at
// runtime there but baked in here at build time, so change both; a test fails until the two files match.
// A host added here for support agent links also becomes a link target (answerLinkHosts.ts) and a source
// for images in AI answers, which load without a click (answerImageHosts.ts), so only add hosts we'd
// trust with all three.
export const ALLOWED_LINK_DOMAINS: readonly string[] = [
    'spiris.se',
    'visma.com',
    'help.visma.net',
    'vismaspcs.se',
    'vismaonline.com',
    'speedledger.se',
    'speedledger.zendesk.com',
    'skatteverket.se',
    'bolagsverket.se',
    'verksamt.se',
    'eaccounting.nl',
];

export function isAllowedLinkHost(hostname: string): boolean {
    return hostMatchesDomain(hostname, ALLOWED_LINK_DOMAINS);
}
